import type { CoachingTier } from '@mlm/shared';
import { useCoachingTierLabels } from '../lib/tier-labels';

/** The tier's name on its own: "Free plan", or whatever the tenant calls the paid tier. */
export function TierName({ tier }: { tier: CoachingTier }) {
  const labels = useCoachingTierLabels();
  return <>{tier === 'free' ? 'Free plan' : labels[tier]}</>;
}

/** Who sees a piece of content: "Everyone", or "{plan} and above". */
export function Audience({ level }: { level: CoachingTier }) {
  const labels = useCoachingTierLabels();
  return <>{level === 'free' ? 'Everyone' : `${labels[level]} and above`}</>;
}
